import React from 'react';

import { Sparkles } from 'lucide-react';
import { PulseIcon, PulseIconVariant } from 'src/components/icons/Pulse';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  content: {
    alignItems: 'center',
    display: 'inline-flex',
    gap: theme.spacing(1),
  },
}));

interface RunStopButtonContentProps {
  isRunning: boolean;
  iconSize?: number;
  label?: string;
}

/**
 * Children for a Run button that turns into Stop while its questions run, so
 * the button keeps its place and only the contents change. The running pulse
 * is drawn in the primary color, so render the button outlined while running.
 */
export const RunStopButtonContent = React.memo(function RunStopButtonContent({
  iconSize = 16,
  isRunning,
  label = 'Aline AI',
}: RunStopButtonContentProps): JSX.Element {
  const { classes } = useStyles();

  if (isRunning)
    return (
      <span className={classes.content}>
        <PulseIcon variant={PulseIconVariant.LoadingPrimary} />
        Stop {label}
      </span>
    );

  return (
    <span className={classes.content}>
      <Sparkles aria-hidden color="currentColor" size={iconSize} />
      Run {label}
    </span>
  );
});
